/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-table/webhook-form-table.component.scss */
td {
  text-overflow: ellipsis;
  overflow: hidden;
  word-spacing: unset;
  width: 100%;
  white-space: nowrap;
}
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  border: 1px solid var(--tem-border);
}
.edit-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.edit-panel-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  border: 1px solid var(--tem-border);
  border-radius: 2px;
  padding: 16px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
td.cell-normal {
  text-overflow: ellipsis;
  overflow: hidden;
  word-spacing: unset;
  width: 100%;
  white-space: nowrap;
}
::ng-deep .ant-table-cell {
  word-break: break-word;
}
.search-box {
  padding: 8px;
}
.search-box input {
  width: 188px;
  margin-bottom: 8px;
  display: block;
}
.search-box button {
  width: 90px;
}
.search-button {
  margin-right: 8px;
}
.edit-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.edit-panel-action {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: 12px 16px;
  color: var(--tem-ink);
  background-color: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-bottom: 0;
  border-radius: 2px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
nz-divider::after,
nz-divider::before {
  border-color: var(--tem-deep) !important;
}
.row-insert-table {
  background-color: var(--tem-accent-soft);
}
/*# sourceMappingURL=webhook-form-table.component.css.map */
